// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607100029/js/" + chunkId + "." + {"44":"8c078f13","225":"c91c5623","481":"9f54491b","486":"1bd1b4d0","770":"d385dcf2"}[chunkId] + ".0.023604801682371446.chunk.js";
};